import React, { useRef, useState, useLayoutEffect } from 'react';

var d3 = require('d3');

var TreeChart = /*#__PURE__*/function () {
  function TreeChart() {
    var _this = this;

    this.locateRecursive = function (d, id) {
      var locateRecurve = _this.locateRecursive;

      if (d.id === id) {
        _this.expandParents(d);
      } else if (d._children) {
        d._children.forEach(function (ch) {
          ch.parent = d;
          locateRecurve(ch, id);
        });
      } else if (d.children) {
        d.children.forEach(function (ch) {
          ch.parent = d;
          locateRecurve(ch, id);
        });
      }
    };

    this.collapse = function (d) {
      if (d.children) {
        d._children = d.children;

        d._children.forEach(function (ch) {
          return _this.collapse(ch);
        });

        d.children = null;
      }
    };

    this.expandParents = function (d) {
      while (d.parent) {
        d = d.parent;

        if (!d.children) {
          d.children = d._children;
          d._children = null;
        }
      }
    };

    var attrs = {
      id: "ID" + Math.floor(Math.random() * 1000000),
      svgWidth: 100,
      svgHeight: 100,
      marginTop: 0,
      marginBottom: 0,
      marginRight: 0,
      marginLeft: 0,
      container: 'body',
      defaultTextFill: '#2C3E50',
      nodeTextFill: 'white',
      defaultFont: 'Helvetica',
      backgroundColor: '#fafafa',
      data: null,
      highligthIds: null,
      higligthClassName: '',
      depth: 180,
      duration: 600,
      strokeWidth: 3,
      dropShadowId: null,
      initialZoom: 1,
      minMaxZoomProportions: [0.05, 3],
      behaviors: null,
      root: {},
      onNodeClick: function onNodeClick(d) {
        return d;
      }
    };

    this.getChartState = function () {
      return attrs;
    };

    Object.keys(attrs).forEach(function (key) {
      _this[key] = function (_) {
        var string = "attrs['" + key + "'] = _";

        if (!arguments.length) {
          return eval("attrs['" + key + "'];");
        }

        eval(string);
        return this;
      };
    });
    this.initializeEnterExitUpdatePattern();
  }

  var _proto = TreeChart.prototype;

  _proto.initializeEnterExitUpdatePattern = function initializeEnterExitUpdatePattern() {
    d3.selection.prototype.patternify = function (params) {
      var container = this;
      var selector = params.selector;
      var elementTag = params.tag;
      var data = params.data || [selector];
      var selection = container.selectAll('.' + selector).data(data, function (d, i) {
        if (typeof d === 'object') {
          if (d.id) {
            return d.id;
          }
        }

        return i;
      });
      selection.exit().remove();
      selection = selection.enter().append(elementTag).merge(selection);
      selection.attr('class', selector);
      return selection;
    };
  };

  _proto.getNodeChildrenIds = function getNodeChildrenIds(_ref, nodeIdsStore) {
    var _this2 = this;

    var data = _ref.data,
        children = _ref.children,
        _children = _ref._children;
    nodeIdsStore.push(data.nodeId);

    if (children) {
      children.forEach(function (d) {
        _this2.getNodeChildrenIds(d, nodeIdsStore);
      });
    }

    if (_children) {
      _children.forEach(function (d) {
        _this2.getNodeChildrenIds(d, nodeIdsStore);
      });
    }

    return nodeIdsStore;
  };

  _proto.locate = function locate(id) {
    var attrs = this.getChartState();
    var locateRecurve = this.locateRecursive;

    if (!attrs.root.children) {
      if (!attrs.root.id === id) {
        attrs.root.children = attrs.root._children;
      }
    }

    if (attrs.root.children) {
      attrs.root.children.forEach(this.collapse);
      attrs.root.children.forEach(function (ch) {
        locateRecurve(ch, id);
      });
    }

    this.update(attrs.root, {
      locate: id
    });
  };

  _proto.explodeOrContract = function explodeOrContract(explode) {
    var _this3 = this;

    var attrs = this.getChartState();
    attrs.root = d3.stratify().id(function (_ref2) {
      var nodeId = _ref2.nodeId;
      return nodeId;
    }).parentId(function (_ref3) {
      var parentNodeId = _ref3.parentNodeId;
      return parentNodeId;
    })(attrs.data);
    attrs.root.x0 = 0;
    attrs.root.y0 = 0;
    attrs.allNodes = attrs.layouts.treemap(attrs.root).descendants();
    attrs.allNodes.forEach(function (d) {
      Object.assign(d.data, {
        directSubordinates: d.children ? d.children.length : 0,
        totalSubordinates: d.descendants().length - 1
      });
    });

    if (explode) {
      attrs.root.children.forEach(this.expand);
    } else {
      attrs.root.children.forEach(function (d) {
        return _this3.collapse(d);
      });
    }

    this.update(attrs.root);
  };

  _proto.setZoomFactor = function setZoomFactor(zoomLevel) {
    var attrs = this.getChartState();
    var calc = attrs.calc;
    attrs.initialZoom = zoomLevel;
    attrs.centerG.attr('transform', " translate(" + calc.centerX + ", " + calc.nodeMaxHeight / 2 + ") scale(" + attrs.initialZoom + ")");
  };

  _proto.render = function render() {
    var _this4 = this;

    var attrs = this.getChartState();
    var container = d3.select(attrs.container);
    var containerRect = container.node().getBoundingClientRect();
    this.setDropShadowId(attrs);
    var calc = {
      id: null,
      chartTopMargin: null,
      chartLeftMargin: null,
      chartWidth: null,
      chartHeight: null
    };
    calc.id = "ID" + Math.floor(Math.random() * 1000000);
    calc.chartLeftMargin = attrs.marginLeft;
    calc.chartTopMargin = attrs.marginTop;
    calc.chartWidth = attrs.svgWidth - attrs.marginRight - calc.chartLeftMargin;
    calc.chartHeight = attrs.svgHeight - attrs.marginBottom - calc.chartTopMargin;
    calc.nodeMaxWidth = d3.max(attrs.data, function (_ref4) {
      var width = _ref4.width;
      return width;
    });
    calc.nodeMaxHeight = d3.max(attrs.data, function (_ref5) {
      var height = _ref5.height;
      return height;
    });
    attrs.depth = calc.nodeMaxHeight + 100;
    calc.centerX = calc.chartWidth / 2;
    attrs.calc = calc;
    var layouts = {
      treemap: null
    };
    attrs.layouts = layouts;
    layouts.treemap = d3.tree().size([calc.chartWidth, calc.chartHeight]).nodeSize([calc.nodeMaxWidth + 100, calc.nodeMaxHeight + attrs.depth]);
    var behaviors = {
      zoom: null
    };
    behaviors.zoom = d3.zoom().on('zoom', function (e) {
      return _this4.zoomed(e);
    });
    attrs.behaviors = behaviors;
    attrs.root = d3.stratify().id(function (_ref6) {
      var nodeId = _ref6.nodeId;
      return nodeId;
    }).parentId(function (_ref7) {
      var parentNodeId = _ref7.parentNodeId;
      return parentNodeId;
    })(attrs.data);
    attrs.root.x0 = 0;
    attrs.root.y0 = 0;
    attrs.allNodes = attrs.layouts.treemap(attrs.root).descendants();
    attrs.allNodes.forEach(function (d) {
      Object.assign(d.data, {
        directSubordinates: d.children ? d.children.length : 0,
        totalSubordinates: d.descendants().length - 1
      });
    });
    attrs.root.children.forEach(function (d) {
      return _this4.collapse(d);
    });
    attrs.root.children.forEach(function (d) {
      return _this4.expandSomeNodes(d);
    });
    var svg = container.patternify({
      tag: 'svg',
      selector: 'svg-chart-container'
    }).attr('width', attrs.svgWidth).attr('height', attrs.svgHeight).attr('font-family', attrs.defaultFont).call(behaviors.zoom).attr('cursor', 'move').style('background-color', attrs.backgroundColor);
    attrs.svg = svg;
    var chart = svg.patternify({
      tag: 'g',
      selector: 'chart'
    }).attr('transform', "translate(" + calc.chartLeftMargin + "," + calc.chartTopMargin + ")");
    attrs.centerG = chart.patternify({
      tag: 'g',
      selector: 'center-group'
    }).attr('transform', "translate(" + calc.centerX + "," + calc.nodeMaxHeight / 2 + ") scale(" + attrs.initialZoom + ")");
    attrs.chart = chart;
    attrs.defs = svg.patternify({
      tag: 'defs',
      selector: 'image-defs'
    });
    var filterDefs = svg.patternify({
      tag: 'defs',
      selector: 'filter-defs'
    });
    var filter = filterDefs.patternify({
      tag: 'filter',
      selector: 'shadow-filter-element'
    }).attr('id', attrs.dropShadowId).attr('y', -50 + "%").attr('x', -50 + "%").attr('height', 200 + "%").attr('width', 200 + "%");
    filter.patternify({
      tag: 'feGaussianBlur',
      selector: 'feGaussianBlur-element'
    }).attr('in', 'SourceAlpha').attr('stdDeviation', 3.1).attr('result', 'blur');
    filter.patternify({
      tag: 'feOffset',
      selector: 'feOffset-element'
    }).attr('in', 'blur').attr('result', 'offsetBlur').attr('dx', 4.28).attr('dy', 4.48).attr('x', 8).attr('y', 8);
    filter.patternify({
      tag: 'feFlood',
      selector: 'feFlood-element'
    }).attr('in', 'offsetBlur').attr('flood-color', 'black').attr('flood-opacity', 0.3).attr('result', 'offsetColor');
    filter.patternify({
      tag: 'feComposite',
      selector: 'feComposite-element'
    }).attr('in', 'offsetColor').attr('in2', 'offsetBlur').attr('operator', 'in').attr('result', 'offsetBlur');
    var feMerge = filter.patternify({
      tag: 'feMerge',
      selector: 'feMerge-element'
    });
    feMerge.patternify({
      tag: 'feMergeNode',
      selector: 'feMergeNode-blur'
    }).attr('in', 'offsetBlur');
    feMerge.patternify({
      tag: 'feMergeNode',
      selector: 'feMergeNode-graphic'
    }).attr('in', 'SourceGraphic');
    this.update(attrs.root);
    d3.select(window).on("resize." + attrs.id, function () {
      var containerRect = container.node().getBoundingClientRect();
    });
    return this;
  };

  _proto.setDropShadowId = function setDropShadowId(d) {
    if (d.dropShadowId) return;
    var id = d.id + "-drop-shadow";

    if (typeof DOM !== 'undefined') {
      id = DOM.uid(d.id).id;
    }

    Object.assign(d, {
      dropShadowId: id
    });
  };

  _proto.addNode = function addNode(obj) {
    var attrs = this.getChartState();
    attrs.data.push(obj);
    this.updateNodesState();
    return this;
  };

  _proto.removeNode = function removeNode(nodeId) {
    var attrs = this.getChartState();
    var node = attrs.allNodes.filter(function (_ref8) {
      var data = _ref8.data;
      return data.nodeId == nodeId;
    })[0];

    if (node) {
      var nodeChildrenIds = this.getNodeChildrenIds(node, []);
      attrs.data = attrs.data.filter(function (d) {
        return !nodeChildrenIds.includes(d.nodeId);
      });
      var updateNodesState = this.updateNodesState.bind(this);
      updateNodesState();
    }
  };

  _proto.update = function update(_ref9, param) {
    var _this5 = this;

    var x0 = _ref9.x0,
        y0 = _ref9.y0,
        x = _ref9.x,
        y = _ref9.y;
    var attrs = this.getChartState();
    var treeData = attrs.layouts.treemap(attrs.root);
    var nodes = treeData.descendants().map(function (d) {
      if (d.width) return d;
      var imageWidth = 100;
      var imageHeight = 100;
      var imageBorderColor = 'steelblue';
      var imageBorderWidth = 0;
      var imageRx = 0;
      var imageCenterTopDistance = 0;
      var imageCenterLeftDistance = 0;
      var borderColor = 'steelblue';
      var backgroundColor = 'steelblue';
      var width = d.data.width;
      var height = d.data.height;
      var dropShadowId = "none";

      if (d.data.nodeImage && d.data.nodeImage.shadow) {
        dropShadowId = "url(#" + attrs.dropShadowId + ")";
      }

      if (d.data.nodeImage && d.data.nodeImage.width) {
        imageWidth = d.data.nodeImage.width;
      }

      if (d.data.nodeImage && d.data.nodeImage.height) {
        imageHeight = d.data.nodeImage.height;
      }

      if (d.data.nodeImage && d.data.nodeImage.borderColor) {
        imageBorderColor = _this5.rgbaObjToColor(d.data.nodeImage.borderColor);
      }

      if (d.data.nodeImage && d.data.nodeImage.borderWidth) {
        imageBorderWidth = d.data.nodeImage.borderWidth;
      }

      if (d.data.nodeImage && d.data.nodeImage.centerTopDistance) {
        imageCenterTopDistance = d.data.nodeImage.centerTopDistance;
      }

      if (d.data.nodeImage && d.data.nodeImage.centerLeftDistance) {
        imageCenterLeftDistance = d.data.nodeImage.centerLeftDistance;
      }

      if (d.data.borderColor) {
        borderColor = _this5.rgbaObjToColor(d.data.borderColor);
      }

      if (d.data.backgroundColor) {
        backgroundColor = _this5.rgbaObjToColor(d.data.backgroundColor);
      }

      if (d.data.nodeImage && d.data.nodeImage.cornerShape.toLowerCase() === 'circle') {
        imageRx = Math.max(imageWidth, imageHeight);
      }

      if (d.data.nodeImage && d.data.nodeImage.cornerShape.toLowerCase() === 'rounded') {
        imageRx = Math.min(imageWidth, imageHeight) / 6;
      }

      return Object.assign(d, {
        imageWidth: imageWidth,
        imageHeight: imageHeight,
        imageBorderColor: imageBorderColor,
        imageBorderWidth: imageBorderWidth,
        borderColor: borderColor,
        backgroundColor: backgroundColor,
        imageRx: imageRx,
        width: width,
        height: height,
        imageCenterTopDistance: imageCenterTopDistance,
        imageCenterLeftDistance: imageCenterLeftDistance,
        dropShadowId: dropShadowId
      });
    });
    var links = treeData.descendants().slice(1);
    nodes.forEach(function (d) {
      return d.y = d.depth * attrs.depth;
    });
    var patternsSelection = attrs.defs.selectAll('.pattern').data(nodes, function (_ref10) {
      var id = _ref10.id;
      return id;
    });
    var patternEnterSelection = patternsSelection.enter().append('pattern');
    var patterns = patternEnterSelection.merge(patternsSelection).attr('class', 'pattern').attr('height', 1).attr('width', 1).attr('id', function (_ref11) {
      var id = _ref11.id;
      return id;
    });
    var patternImages = patterns.patternify({
      tag: 'image',
      selector: 'pattern-image',
      data: function data(d) {
        return [d];
      }
    }).attr('x', 0).attr('y', 0).attr('height', function (_ref12) {
      var imageWidth = _ref12.imageWidth;
      return imageWidth;
    }).attr('width', function (_ref13) {
      var imageHeight = _ref13.imageHeight;
      return imageHeight;
    }).attr('xlink:href', function (_ref14) {
      var data = _ref14.data;
      return data.nodeImage && data.nodeImage.url;
    }).attr('viewbox', function (_ref15) {
      var imageWidth = _ref15.imageWidth,
          imageHeight = _ref15.imageHeight;
      return "0 0 " + imageWidth * 2 + " " + imageHeight;
    }).attr('preserveAspectRatio', 'xMidYMin slice');
    patternsSelection.exit().transition().duration(attrs.duration).remove();
    var linkSelection = attrs.centerG.selectAll('path.link').data(links, function (_ref16) {
      var id = _ref16.id;
      return id;
    });
    var linkEnter = linkSelection.enter().insert('path', 'g').attr('class', 'link').attr('d', function (d) {
      var o = {
        x: x0,
        y: y0
      };
      return _this5.diagonal(o, o);
    });
    var linkUpdate = linkEnter.merge(linkSelection);
    linkUpdate.attr('fill', 'none').attr('stroke-width', function (_ref17) {
      var data = _ref17.data;
      return data.connectorLineWidth || 2;
    }).attr('stroke', function (_ref18) {
      var data = _ref18.data;

      if (data.connectorLineColor) {
        return _this5.rgbaObjToColor(data.connectorLineColor);
      }

      return 'green';
    }).attr('stroke-dasharray', function (_ref19) {
      var data = _ref19.data;

      if (data.dashArray) {
        return data.dashArray;
      }

      return '';
    });
    linkUpdate.transition().duration(attrs.duration).attr('d', function (d) {
      return _this5.diagonal(d, d.parent);
    });
    var linkExit = linkSelection.exit().transition().duration(attrs.duration).attr('d', function (d) {
      var o = {
        x: x,
        y: y
      };
      return _this5.diagonal(o, o);
    }).remove();
    var nodesSelection = attrs.centerG.selectAll('g.node').data(nodes, function (_ref20) {
      var id = _ref20.id;
      return id;
    });
    var nodeEnter = nodesSelection.enter().append('g').attr('class', 'node').attr('transform', function (d) {
      return "translate(" + x0 + "," + y0 + ")";
    }).attr('cursor', 'pointer').on('click', function (_ref21) {
      var data = _ref21.data;

      if ([].concat(d3.event.srcElement.classList).includes('node-button-circle')) {
        return;
      }

      attrs.onNodeClick(data.nodeId);
    });
    nodeEnter.patternify({
      tag: 'rect',
      selector: 'node-rect',
      data: function data(d) {
        return [d];
      }
    }).style('fill', function (_ref22) {
      var _children = _ref22._children;
      return _children ? 'lightsteelblue' : '#fff';
    });
    var nodeImageGroups = nodeEnter.patternify({
      tag: 'g',
      selector: 'node-image-group',
      data: function data(d) {
        return [d];
      }
    });
    nodeImageGroups.patternify({
      tag: 'rect',
      selector: 'node-image-rect',
      data: function data(d) {
        return [d];
      }
    });
    var nodeUpdate = nodeEnter.merge(nodesSelection).style('font', '12px sans-serif');
    var fo = nodeUpdate.patternify({
      tag: 'foreignObject',
      selector: 'node-foreign-object',
      data: function data(d) {
        return [d];
      }
    });
    fo.patternify({
      tag: 'xhtml:div',
      selector: 'node-foreign-object-div',
      data: function data(d) {
        return [d];
      }
    });
    this.restyleForeignObjectElements();
    var nodeButtonGroups = nodeEnter.patternify({
      tag: 'g',
      selector: 'node-button-g',
      data: function data(d) {
        return [d];
      }
    }).on('click', function (d) {
      return _this5.onButtonClick(d);
    });
    nodeButtonGroups.patternify({
      tag: 'circle',
      selector: 'node-button-circle',
      data: function data(d) {
        return [d];
      }
    });
    nodeButtonGroups.patternify({
      tag: 'text',
      selector: 'node-button-text',
      data: function data(d) {
        return [d];
      }
    }).attr('pointer-events', 'none');
    nodeUpdate.transition().attr('opacity', 0).duration(attrs.duration).attr('transform', function (_ref23) {
      var x = _ref23.x,
          y = _ref23.y;
      return "translate(" + x + "," + y + ")";
    }).attr('opacity', 1);
    nodeUpdate.selectAll('.node-image-group').attr('transform', function (_ref24) {
      var imageWidth = _ref24.imageWidth,
          width = _ref24.width,
          imageHeight = _ref24.imageHeight,
          height = _ref24.height;
      var x = -imageWidth / 2 - width / 2;
      var y = -imageHeight / 2 - height / 2;
      return "translate(" + x + "," + y + ")";
    });
    nodeUpdate.select('.node-image-rect').attr('fill', function (_ref25) {
      var id = _ref25.id;
      return "url(#" + id + ")";
    }).attr('width', function (_ref26) {
      var imageWidth = _ref26.imageWidth;
      return imageWidth;
    }).attr('height', function (_ref27) {
      var imageHeight = _ref27.imageHeight;
      return imageHeight;
    }).attr('stroke', function (_ref28) {
      var imageBorderColor = _ref28.imageBorderColor;
      return imageBorderColor;
    }).attr('stroke-width', function (_ref29) {
      var imageBorderWidth = _ref29.imageBorderWidth;
      return imageBorderWidth;
    }).attr('rx', function (_ref30) {
      var imageRx = _ref30.imageRx;
      return imageRx;
    }).attr('y', function (_ref31) {
      var imageCenterTopDistance = _ref31.imageCenterTopDistance;
      return imageCenterTopDistance;
    }).attr('x', function (_ref32) {
      var imageCenterLeftDistance = _ref32.imageCenterLeftDistance;
      return imageCenterLeftDistance;
    }).attr('filter', function (_ref33) {
      var dropShadowId = _ref33.dropShadowId;
      return dropShadowId;
    });
    nodeUpdate.select('.node-rect').attr('class', function (_ref34) {
      var data = _ref34.data;

      if (attrs.highligthIds && attrs.highligthIds.includes(data.nodeId)) {
        return '.node-rect' + ' ' + attrs.higligthClassName;
      }

      return 'node-rect';
    }).attr('width', function (_ref35) {
      var data = _ref35.data;
      return data.width;
    }).attr('height', function (_ref36) {
      var data = _ref36.data;
      return data.height;
    }).attr('x', function (_ref37) {
      var data = _ref37.data;
      return -data.width / 2;
    }).attr('y', function (_ref38) {
      var data = _ref38.data;
      return -data.height / 2;
    }).attr('rx', function (_ref39) {
      var data = _ref39.data;
      return data.borderRadius || 0;
    }).attr('stroke-width', function (_ref40) {
      var data = _ref40.data;

      if (param && data.nodeId === param.locate) {
        return '5';
      }

      return data.borderWidth || attrs.strokeWidth;
    }).attr('cursor', 'pointer').attr('stroke', function (_ref41) {
      var borderColor = _ref41.borderColor,
          data = _ref41.data;

      if (param && data.nodeId === param.locate) {
        return '#ff0000';
      }

      return borderColor;
    }).attr('id', function (_ref42) {
      var data = _ref42.data;
      return data.nodeId;
    }).style('fill', function (_ref43) {
      var backgroundColor = _ref43.backgroundColor;
      return backgroundColor;
    });
    nodeUpdate.select('.node-button-g').attr('transform', function (_ref44) {
      var data = _ref44.data;
      return "translate(0," + data.height / 2 + ")";
    }).attr('opacity', function (_ref45) {
      var children = _ref45.children,
          _children = _ref45._children;

      if (children || _children) {
        return 1;
      }

      return 0;
    });
    nodeUpdate.select('.node-button-circle').attr('r', 16).attr('stroke-width', function (_ref46) {
      var data = _ref46.data;
      return data.borderWidth || attrs.strokeWidth;
    }).attr('fill', attrs.backgroundColor).attr('stroke', function (_ref47) {
      var borderColor = _ref47.borderColor;
      return borderColor;
    });
    nodeUpdate.select('.node-button-text').attr('text-anchor', 'middle').attr('alignment-baseline', 'middle').attr('fill', attrs.defaultTextFill).attr('font-size', function (_ref48) {
      var children = _ref48.children;
      if (children) return 40;
      return 26;
    }).text(function (_ref49) {
      var children = _ref49.children;
      if (children) return '-';
      return '+';
    }).attr('y', 0);
    var nodeExitTransition = nodesSelection.exit().attr('opacity', 1).transition().duration(attrs.duration).attr('transform', function (d) {
      return "translate(" + x + "," + y + ")";
    }).on('end', function () {
      d3.select(this).remove();
    }).attr('opacity', 0);
    nodeExitTransition.selectAll('.node-rect').attr('width', 10).attr('height', 10).attr('x', 0).attr('y', 0);
    nodeExitTransition.selectAll('.node-image-rect').attr('width', 10).attr('height', 10).attr('x', function (_ref50) {
      var width = _ref50.width;
      return width / 2;
    }).attr('y', function (_ref51) {
      var height = _ref51.height;
      return height / 2;
    });
    nodes.forEach(function (d) {
      d.x0 = d.x;
      d.y0 = d.y;
    });

    if (param && param.locate) {
      var _x;

      var _y;

      nodes.forEach(function (d) {
        if (d.id === param.locate) {
          _x = d.x;
          _y = d.y;
        }
      });
      var newZoom = 2;
      var normalizedTochartX = _x * attrs.initialZoom + attrs.calc.centerX;
      var normalizedTochartY = _y * attrs.initialZoom + attrs.calc.nodeMaxHeight / 2;
      var newX = -normalizedTochartX * newZoom + attrs.svgWidth / 2;
      var newY = -normalizedTochartY * newZoom + attrs.svgHeight / 2;
      var t = d3.zoomIdentity.translate(newX, newY).scale(newZoom);
      attrs.svg.transition().duration(attrs.duration).call(attrs.behaviors.zoom.transform, t);
    }
  };

  _proto.isEdge = function isEdge() {
    return window.navigator.userAgent.includes('Edge');
  };

  _proto.rgbaObjToColor = function rgbaObjToColor(_ref52) {
    var red = _ref52.red,
        green = _ref52.green,
        blue = _ref52.blue,
        alpha = _ref52.alpha;
    return "rgba(" + red + "," + green + "," + blue + "," + alpha + ")";
  };

  _proto.diagonal = function diagonal(s, t) {
    var x = s.x;
    var y = s.y;
    var ex = t.x;
    var ey = t.y;
    var xrvs = ex - x < 0 ? -1 : 1;
    var yrvs = ey - y < 0 ? -1 : 1;
    var rdef = 35;
    var rInitial = Math.abs(ex - x) / 2 < rdef ? Math.abs(ex - x) / 2 : rdef;
    var r = Math.abs(ey - y) / 2 < rInitial ? Math.abs(ey - y) / 2 : rInitial;
    var h = Math.abs(ey - y) / 2 - r;
    var w = Math.abs(ex - x) - r * 2;
    var path = "\n             M " + x + " " + y + "\n             L " + x + " " + (y + h * yrvs) + "\n             C  " + x + " " + (y + h * yrvs + r * yrvs) + " " + x + " " + (y + h * yrvs + r * yrvs) + " " + (x + r * xrvs) + " " + (y + h * yrvs + r * yrvs) + "\n             L " + (x + w * xrvs + r * xrvs) + " " + (y + h * yrvs + r * yrvs) + "\n             C " + ex + "  " + (y + h * yrvs + r * yrvs) + " " + ex + "  " + (y + h * yrvs + r * yrvs) + " " + ex + " " + (ey - h * yrvs) + "\n             L " + ex + " " + ey + "\n           ";
    return path;
  };

  _proto.restyleForeignObjectElements = function restyleForeignObjectElements() {
    var attrs = this.getChartState();
    attrs.svg.selectAll('.node-foreign-object').attr('width', function (_ref53) {
      var width = _ref53.width;
      return width;
    }).attr('height', function (_ref54) {
      var height = _ref54.height;
      return height;
    }).attr('x', function (_ref55) {
      var width = _ref55.width;
      return -width / 2;
    }).attr('y', function (_ref56) {
      var height = _ref56.height;
      return -height / 2;
    });
    attrs.svg.selectAll('.node-foreign-object-div').style('width', function (_ref57) {
      var width = _ref57.width;
      return width + "px";
    }).style('height', function (_ref58) {
      var height = _ref58.height;
      return height + "px";
    }).style('color', 'white').html(function (_ref59) {
      var data = _ref59.data;
      return data.template;
    });
  };

  _proto.onButtonClick = function onButtonClick(d) {
    if (d.children) {
      d._children = d.children;
      d.children = null;
      this.setExpansionFlagToChildren(d, false);
    } else {
      d.children = d._children;
      d._children = null;
      d.children.forEach(function (_ref60) {
        var data = _ref60.data;
        return data.expanded = true;
      });
    }

    this.update(d);
  };

  _proto.setExpansionFlagToChildren = function setExpansionFlagToChildren(_ref61, flag) {
    var _this6 = this;

    var data = _ref61.data,
        children = _ref61.children,
        _children = _ref61._children;
    data.expanded = flag;

    if (children) {
      children.forEach(function (d) {
        _this6.setExpansionFlagToChildren(d, flag);
      });
    }

    if (_children) {
      _children.forEach(function (d) {
        _this6.setExpansionFlagToChildren(d, flag);
      });
    }
  };

  _proto.setExpanded = function setExpanded(id, expandedFlag) {
    var _this7 = this;

    var attrs = this.getChartState();
    var node = attrs.allNodes.filter(function (_ref62) {
      var data = _ref62.data;
      return data.nodeId === id;
    })[0];
    if (node) node.data.expanded = expandedFlag;
    attrs.root.children.forEach(function (d) {
      return _this7.expand(d);
    });
    attrs.root.children.forEach(function (d) {
      return _this7.collapse(d);
    });
    attrs.root.children.forEach(function (d) {
      return _this7.expandSomeNodes(d);
    });
    this.update(attrs.root);
  };

  _proto.setExpandedArray = function setExpandedArray(idArray, expandedFlag) {
    var _this8 = this;

    var attrs = this.getChartState();
    idArray.forEach(function (id) {
      var node = attrs.allNodes.filter(function (_ref63) {
        var data = _ref63.data;
        return data.nodeId === id;
      })[0];
      if (node) node.data.expanded = expandedFlag;
    });
    attrs.root.children.forEach(function (d) {
      return _this8.expand(d);
    });
    attrs.root.children.forEach(function (d) {
      return _this8.collapse(d);
    });
    attrs.root.children.forEach(function (d) {
      return _this8.expandSomeNodes(d);
    });
    this.update(attrs.root);
  };

  _proto.expandSomeNodes = function expandSomeNodes(d) {
    var _this9 = this;

    if (d.data.expanded) {
      var parent = d.parent;

      while (parent) {
        if (parent._children) {
          parent.children = parent._children;
        }

        parent = parent.parent;
      }
    }

    if (d._children) {
      d._children.forEach(function (ch) {
        return _this9.expandSomeNodes(ch);
      });
    }

    if (d.children) {
      d.children.forEach(function (ch) {
        return _this9.expandSomeNodes(ch);
      });
    }
  };

  _proto.updateNodesState = function updateNodesState() {
    var _this10 = this;

    var attrs = this.getChartState();
    attrs.root = d3.stratify().id(function (_ref64) {
      var nodeId = _ref64.nodeId;
      return nodeId;
    }).parentId(function (_ref65) {
      var parentNodeId = _ref65.parentNodeId;
      return parentNodeId;
    })(attrs.data);
    attrs.root.x0 = 0;
    attrs.root.y0 = 0;
    attrs.allNodes = attrs.layouts.treemap(attrs.root).descendants();
    attrs.allNodes.forEach(function (d) {
      Object.assign(d.data, {
        directSubordinates: d.children ? d.children.length : 0,
        totalSubordinates: d.descendants().length - 1
      });
    });
    attrs.root.children.forEach(this.expand);
    attrs.root.children.forEach(function (d) {
      return _this10.collapse(d);
    });
    attrs.root.children.forEach(function (ch) {
      return _this10.expandSomeNodes(ch);
    });
    this.update(attrs.root);
  };

  _proto.expand = function expand(d) {
    var _this11 = this;

    if (d._children) {
      d.children = d._children;
      d.children.forEach(function (ch) {
        return _this11.expand(ch);
      });
      d._children = null;
    }
  };

  _proto.findmySelf = function findmySelf(d) {
    if (d.isLoggedUser) {
      this.expandParents(d);
    } else if (d._children) {
      d._children.forEach(function (ch) {
        ch.parent = d;
        this.findmySelf(ch);
      });
    } else if (d.children) {
      d.children.forEach(function (ch) {
        ch.parent = d;
        this.findmySelf(ch);
      });
    }
  };

  _proto.zoomed = function zoomed() {
    var attrs = this.getChartState();
    var chart = attrs.chart;
    var transform = d3.event.transform;
    attrs.lastTransform = transform;
    chart.attr('transform', transform);

    if (this.isEdge()) {
      this.restyleForeignObjectElements();
    }
  };

  return TreeChart;
}();

var OrganisationalChart = React.forwardRef(function (_ref, ref) {
  var data = _ref.data,
      onNodeClick = _ref.onNodeClick,
      width = _ref.width,
      height = _ref.height,
      zoom = _ref.zoom,
      highligthIds = _ref.highligthIds,
      higligthClassName = _ref.higligthClassName;
  var d3Container = useRef(null);

  var _useState = useState(null),
      chart = _useState[0],
      setChart = _useState[1];

  var _useState2 = useState('O-498');

  useLayoutEffect(function () {
    if (data && d3Container.current) var newChart;

    if (!chart) {
      newChart = new TreeChart();
    }

    if (newChart) {
      newChart.container(d3Container.current).data(data).highligthIds(highligthIds || []).higligthClassName(higligthClassName || '').svgWidth(width).svgHeight(height).initialZoom(zoom).onNodeClick(function (id) {
        onNodeClick(id);
      }).render();
      setChart(newChart);
    }
  }, [data, d3Container.current]);

  if (chart) {
    ref(chart);
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    ref: d3Container
  }));
});
export { OrganisationalChart };